"use client";
import { SetStateAction, useState } from "react";
import DocumentMeta from "react-document-meta";

import Carousel from "react-material-ui-carousel";

import {
  Box,
  Typography
} from "@mui/material";

import FooterComponent from "../../components/footer";
import Header from "../../components/header/header";
import "./about.css";

export default function About(): JSX.Element {
  const [message, setMessage] = useState("");

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);
  };
  const [open, setOpenState] = useState(false);

  const meta = {
    title: "About us | 123Skincare",
    description:
      "We cover more than 300 products, among the best skincare products, thanks to our experience with skincare, marketing and tech.",
    canonical: "https://www.123skincare.pro/about",
  };
  return (
    <DocumentMeta {...meta}>
      <Box className="about-us-page"
        sx={{
          width: "100%",
          margin: "0 auto",
        }}
      >
        <Header showLogo={true} />
        <div className="main">
          <div className="container">
            <div className="wrapper">
            

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "12px 0 12px 0",
          }}
        >
          <Box
            sx={{
              padding: { xs: "20px 10px", sm: "20px 15%" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "column" },
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography width={"100%"} variant={"h6"} textAlign="center">
                  Who we are
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h4"} textAlign="center">
                  Here to help you with your skincare needs
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "20px 20px",
                }}
              >
                <Typography
                  variant={"subtitle1"}
                  textAlign="center"
                >
                  Here to simplify the path to finding the right skincare
                  products tailored to your needs. We do this for people who
                  don't have the time or knowledge to navigate the process. We
                  have assisted numerous individuals, just like you
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "20px 20px",
                }}
              >
                <img
                  alt=""
                  src="/assets/about01.png"
                  width="100%"
                  style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "12px 0 12px 0",
          }}
        >
          <Box
            sx={{
              padding: { xs: "20px 10px", sm: "20px 15%" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "column" },
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h4"} textAlign="center">
                  Team
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: { xs: "flex", sm: "none" },
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-around",
          }}
        >
          <Carousel
            fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
            swipe={true}
            animation={"slide"}
            duration={1500}
            interval={10000}
          >
            <Box
              sx={{
                padding: "20px",
                borderRadius: "8px",
                background: "white",
                minWidth: "150px",
                maxWidth: { xs: "100%", sm: "250px" },
                width: { xs: "100%", sm: "23%" },
                textAlign: "center",
              }}
            >
              <a
                target="_blank"
                href="https://www.linkedin.com/in/cristian-veronesi/"
              >
                <img
                  alt=""
                  src="/assets/about-cristian.jpg"
                  width="125px"
                  height="125px"
                  style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
                />
              </a>
              <br />
              Cristian Veronesi
              <br />
              CEO
            </Box>
            <Box
              sx={{
                padding: "20px",
                borderRadius: "8px",
                background: "white",
                minWidth: "150px",
                maxWidth: { xs: "100%", sm: "250px" },
                width: { xs: "100%", sm: "23%" },
                textAlign: "center",
              }}
            >
              <a
                target="_blank"
                href="https://www.linkedin.com/in/xiaomeng-liu-cristina/"
              >
                <img
                  alt=""
                  src="/assets/cristina.png"
                  width="125px"
                  height="125px"
                  style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
                />
              </a>
              <br />
              Xiaomeng Liu
              <br />
              Head of Product
            </Box>
            <Box
              sx={{
                padding: "20px",
                borderRadius: "8px",
                background: "white",
                minWidth: "150px",
                maxWidth: { xs: "100%", sm: "250px" },
                width: { xs: "100%", sm: "23%" },
                textAlign: "center",
              }}
            >
              <a
                target="_blank"
                href="https://www.linkedin.com/in/xiang-xu-8b027343/"
              >
                <img
                  alt=""
                  src="/assets/xiang.png"
                  width="125px"
                  height="125px"
                  style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
                />
              </a>
              <br />
              Xiang Xu
              <br />
              Software engineer
            </Box>
          </Carousel>
        </Box>

        <Box className="members"
          sx={{
            width: "100%",
            display: { xs: "none", sm: "flex" },
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              padding: "20px",
              borderRadius: "8px",
              background: "white",
              minWidth: "150px",
              maxWidth: { xs: "100%", sm: "250px" },
              width: { xs: "100%", sm: "23%" },
              textAlign: "center",
            }}
          >
            <a
              target="_blank"
              href="https://www.linkedin.com/in/cristian-veronesi/"
            >
              <img
                alt=""
                src="/assets/about-cristian.jpg"
                width="125px"
                height="125px"
                style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
              />
            </a>
            <br />
            Cristian Veronesi
            <br />
            CEO
          </Box>
          <Box
            sx={{
              padding: "20px",
              borderRadius: "8px",
              background: "white",
              minWidth: "150px",
              maxWidth: { xs: "100%", sm: "250px" },
              width: { xs: "100%", sm: "23%" },
              textAlign: "center",
            }}
          >
            <a
              target="_blank"
              href="https://www.linkedin.com/in/xiaomeng-liu-cristina/"
            >
              <img
                alt=""
                src="/assets/cristina.png"
                width="125px"
                height="125px"
                style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
              />
            </a>
            <br />
            Xiaomeng Liu
            <br />
            Head of Product
          </Box>
          <Box
            sx={{
              padding: "20px",
              borderRadius: "8px",
              background: "white",
              minWidth: "150px",
              maxWidth: { xs: "100%", sm: "250px" },
              width: { xs: "100%", sm: "23%" },
              textAlign: "center",
            }}
          >
            <a
              target="_blank"
              href="https://www.linkedin.com/in/xiang-xu-8b027343/"
            >
              <img
                alt=""
                src="/assets/xiang.png"
                width="125px"
                height="125px"
                style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
              />
            </a>
            <br />
            Xiang Xu
            <br />
            Software engineer
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "12px 0 12px 0",
          }}
        >
          <Box
            sx={{
              padding: { xs: "20px 10px", sm: "20px 15%" },
            }}
          >
            <Box
              id="work-with-us"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "column" },
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h4"} textAlign="center">
                  Work with us
                </Typography>
              </Box>

              <Box
                sx={{
                  padding: "20px 20px",
                }}
              >
                <Typography
                  variant={"subtitle1"}
                  textAlign="center"
                >
                  We are seeking team members to join our community of skincare
                  enthusiasts. If you are a software engineer, sales
                  professional, or marketing expert interested in joining us,
                  please send an email to cristian@123skincare.pro
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <FooterComponent />

        </div>
          </div>
        </div>
      </Box>
    </DocumentMeta>
  );
}
